export enum SearhApiInputEnum {
    contentType,
    text,
    choice,
    dateTime,
    boolean,
    number,
    taxonomy,
    user,
    lookup
}
